/** Indian GSTIN (Goods and Services Tax Identification Number) — 15 characters. */
export const INDIAN_GSTIN_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const INDIAN_GSTIN_LENGTH = 15;

export const INDIAN_GSTIN_EXAMPLE = "22AAAAA0000A1Z5";

export function normalizeIndianGstinInput(raw: string): string {
  return raw.toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, INDIAN_GSTIN_LENGTH);
}

export function isValidIndianGstin(gstin: string): boolean {
  const normalized = normalizeIndianGstinInput(gstin);
  return normalized.length === INDIAN_GSTIN_LENGTH && INDIAN_GSTIN_REGEX.test(normalized);
}

export function getIndianGstinValidationError(gstin: string): string | null {
  const normalized = normalizeIndianGstinInput(gstin);
  if (!normalized.length) return "Registration number is required";
  if (normalized.length !== INDIAN_GSTIN_LENGTH) {
    return `GSTIN must be exactly ${INDIAN_GSTIN_LENGTH} characters`;
  }
  if (!INDIAN_GSTIN_REGEX.test(normalized)) {
    return `Invalid GSTIN format (e.g. ${INDIAN_GSTIN_EXAMPLE})`;
  }
  return null;
}
